import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { CardWrapperModule } from '@personal-area/global/ui';

@Component({
    selector: 'global-account-viewer-fallback',
    templateUrl: './account-viewer-fallback.component.html',
    styleUrls: ['./account-viewer-fallback.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CardWrapperModule, TranslateModule, RouterModule]
})
export class AccountViewerFallbackComponent {}
